import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg";
import linkedIn from "../../assets/linkedin-icon.svg";

export function Contact() {
  return (
    <Container id="contact">
      <header>
        <h2>Contact</h2>
        <p>Here is my main contact information. </p>
        <p>Don't hesitate to contact me anytime, wherever you are.</p>
      </header>
      <div className="contacts">
        <div>
          <a href="mailto:obadatumah19@gmail.com">
            <img src={emailIcon} alt="Email" />
          </a>
          <a href="mailto:obadatumah19@gmail.com" className="whiteColor">obadatumah19@gmail.com</a>
        </div>
        <div>
          <a href="tel:+962781578715">
            <img src={phoneIcon} alt="Phone No" />
          </a>
          <a href="tel:+962781578715" className="whiteColor">(+962) 781578715</a>
        </div>
        <div>
          <a
            href="https://www.linkedin.com/in/obada19/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={linkedIn} alt="linkedin" />
          </a>
          <a
            href="https://www.linkedin.com/in/obada19/"
            target="_blank"
            rel="noreferrer"
            className="whiteColor"
          >
            Obada Tumah
          </a>
        </div>
      </div>
    </Container>
  );
}
